import { defineStore, storeToRefs } from 'pinia';

import { ref, watch } from 'vue';

import { useCustomizerStore } from './customizer';

// eslint-disable-next-line import/prefer-default-export
export const useCustomizerWatcherStore = defineStore('customizerWatcher', () => {
    const customizerStore = useCustomizerStore();

    const options = ref(null);

    const {
        targetGroupPersonalizationType,
        selectedGroupItem,
        groupPersonalization,
    } = storeToRefs(customizerStore);

    watch(groupPersonalization, () => {
        customizerStore.calculatePrice();
    }, {
        deep: true,
    });

    watch(targetGroupPersonalizationType, () => {
        customizerStore.validateGroupPersonalization();
    });

    watch(selectedGroupItem, () => {
        customizerStore.syncGroupPersonalization();
    });

    function setOptions(v) {
        options.value = v;
    }

    return {
        options,
        setOptions,
    };
});
